module.exports = __webpack_public_path__ + "img/horizontal_7_3_5010.d0ecad45.png";